import type { NavItem } from '@examflow/ui';

/** Primary shell destinations only — mock / diagnosis stay under workspace「更多工具». */
export const layoutNavItems: NavItem[] = [
  { key: 'overview', label: '总览' },
  { key: 'training', label: '专项训练' },
];

export const layoutNavKeyToPath: Record<string, string> = {
  overview: '/workspace',
  training: '/training',
};

export const layoutPathToNavKey: Record<string, string> = {
  '/workspace': 'overview',
  '/training': 'training',
};

export function resolveLayoutNavKey(pathname: string): string {
  return (
    Object.entries(layoutPathToNavKey).find(([path]) => pathname.startsWith(path))?.[1] ??
    'overview'
  );
}
